export default __webpack_public_path__ + "static/media/justsigns.b6e2b602.png";